import React from "react";
import "../css/skill.css";

const skillGroups = [
  {
    title: "Frontend",
    items: [
      "React.js",
      "Next.js",
      "JavaScript",
      "TypeScript",
      "HTML5",
      "CSS3",
      "Responsive UI",
    ],
  },
  {
    title: "Backend",
    items: [
      "Node.js",
      "Express",
      ".NET",
      "C#",
      "ASP.NET",
      "REST APIs",
      "Authentication & Authorization",
    ],
  },
  {
    title: "Mobile",
    items: [
      "Flutter",
      "Dart",
      "Firebase",
      "Offline-first Apps",
      "Mobile UX",
      "Mini-app Integration",
    ],
  },
  {
    title: "Data & DevOps",
    items: [
      "SQL Server",
      "MySQL",
      "MongoDB",
      "PostgreSQL",
      "Docker",
      "Kubernetes",
      "Jenkins",
      "GitLab CI/CD",
      "IIS",
      "Linux Server",
    ],
  },
];

export const Skills = () => (
  <section id="skills" className="skills-section">
    <div className="section-header">
      <span className="section-tag">Skills & Capabilities</span>
      <h2>Technical Expertise</h2>
    </div>

    <div className="skills-layout">
      <div className="skills-copy">
        <p>
          I turn complex business problems into reliable, secure, and scalable
          software. My work spans fintech, banking, telecom, and enterprise ERP
          — from backend services and mobile experiences to CI/CD pipelines —
          always built with clean architecture, long-term maintainability, and
          real business impact in mind.
        </p>
        <div className="stats-row">
          <div>
            <strong>20+</strong>
            <span>Business and product projects</span>
          </div>
          <div>
            <strong>5</strong>
            <span>Core solution domains</span>
          </div>
        </div>
      </div>

      <div className="skills-grid">
        {skillGroups.map((group) => (
          <div className="skill-group" key={group.title}>
            <h3>{group.title}</h3>
            <div className="skill-tags">
              {group.items.map((item) => (
                <span key={item} className="skill-tag">
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
